import { Component, input, InputSignal } from '@angular/core';

import { MDContentBoxComponent, MDIconComponent } from '@melodic-ui/components';
import { IconRef } from '@melodic-ui/types';

@Component({
	selector: 'lb-profile-info-box',
	standalone: true,
	imports: [MDContentBoxComponent, MDIconComponent],
	templateUrl: './profile-info-box.component.html',
	styleUrl: './profile-info-box.component.scss'
})
export class ProfileInfoBoxComponent {
	public infoBoxIcon: InputSignal<IconRef> = input.required<IconRef>();
}
